import React, { useMemo } from "react";
import styles from "./index.module.scss";
import ProgressCirle from "../../../../../components/ProgressCirle";
import { Col, Icon, Row } from "antd";
import { useToggle } from "react-use";

interface Props {
    img: string;
    title: string;
    item: string[];
    other: string;
}
const Index = ({ img, title, item, other }: Props) => {
    const info = useMemo(() => {
        return item[0];
    }, [item]);

    const otherInfo = useMemo(() => {
        return {
            progress: other.split(",")[1],
            text: other.split(",")[0]
        };
    }, [other]);

    const moreInfo = useMemo(() => {
        item.shift();
        return item;
    }, [item]);

    const [show, toggleShow] = useToggle(false);

    return (
        <div className={styles.root}>
            {other && (
                <ProgressCirle
                    className={styles.progress}
                    size={75}
                    progress={otherInfo.progress}
                    width={4}>
                    <div className={styles.scope}>
                        <h1>{otherInfo.progress}</h1>
                        <p>{otherInfo.text}</p>
                    </div>
                </ProgressCirle>
            )}
            <div className={styles.title}>
                <div className={styles.titleLeft}>
                    <img src={img} alt="" />
                    {title}
                </div>
            </div>
            <div className={styles.info}>{info}</div>
            {moreInfo.length > 0 && (
                <>
                    <p className={styles.more} onClick={toggleShow}>
                        查看更多
                        {show ? (
                            <Icon className={styles.moreIcon} type="caret-up" />
                        ) : (
                            <Icon
                                className={styles.moreIcon}
                                type="caret-down"
                            />
                        )}
                    </p>
                    {show && (
                        <Row className={styles.moreRow}>
                            {item.map(i => (
                                <Col key={i} span={item.length > 2 ? 12 : 24}>
                                    <p className={styles.info}>{i}</p>
                                </Col>
                            ))}
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

export default Index;
